export default "__VITE_ASSET__GkyHiaUR__"